import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/game/_components/PuzzleLoader.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/game/_components/roundGame/RoundGame.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/game/templates/index.tsx")